var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWaterMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 378,
    height: 280,
    viewBox: "0 0 378 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194 386C300.039 386 386 300.039 386 194C386 87.9613 300.039 2 194 2C87.9613 2 2 87.9613 2 194C2 300.039 87.9613 386 194 386ZM388 194C388 301.143 301.143 388 194 388C86.8568 388 0 301.143 0 194C0 86.8568 86.8568 0 194 0C301.143 0 388 86.8568 388 194ZM193.999 334.948C271.843 334.948 334.948 271.843 334.948 193.999C334.948 116.156 271.843 53.0508 193.999 53.0508C116.156 53.0508 53.0508 116.156 53.0508 193.999C53.0508 271.843 116.156 334.948 193.999 334.948ZM336.948 193.999C336.948 272.948 272.948 336.948 193.999 336.948C115.051 336.948 51.0508 272.948 51.0508 193.999C51.0508 115.051 115.051 51.0508 193.999 51.0508C272.948 51.0508 336.948 115.051 336.948 193.999ZM197.806 247.953L209.156 220.429L166.921 178.285L139.355 189.711L119.335 169.692L117.786 168.144L119.831 167.361L249.357 117.786L270.214 138.624L220.681 268.165L219.897 270.214L218.352 268.657L197.806 247.953ZM166.155 176.437L139.824 187.351L121.38 168.91L248.861 120.117L267.883 139.121L219.135 266.607L200.162 247.487L211.005 221.192L211.514 219.957L210.569 219.014L168.334 176.869L167.388 175.926L166.155 176.437ZM150.919 209.405L132.426 254.023L131.343 256.635L133.956 255.554L178.616 237.077L180.617 236.249L179.085 234.718L153.279 208.935L151.748 207.406L150.919 209.405ZM152.45 210.934L135.039 252.941L177.084 235.546L152.45 210.934Z",
    fill: "url(#paint0_linear_30452_9242)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30452_9242",
    x1: 75.3974,
    y1: -24.1441,
    x2: 227.039,
    y2: 238.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterMark);
export default __webpack_public_path__ + "static/media/water-mark.2b938316bfb5f289139454b64adbfbf5.svg";
export { ForwardRef as ReactComponent };